import styles from './index.module.scss';
import TextInput from "@/app/_components/Shared/TextInput";
import CustomSelect from "@/app/_components/Shared/CustomSelect";
import {services} from "@/app/_components/Shared/ContactUs/data";

// Radio button options
const options = [
    'Yes',
    'No',
];
const shareHolderOptions = [
    '1',
    '2-5',
    '5+',
];

const businessActivities = [
    'Advertising',
    'Agriculture',
    'Automotive',
    'Business Services',
    'Construction',
    'Education',
    'Entertainment',
    'Financial Services',
    'Healthcare',
    'Hospitality',
    'Information Technology',
    'Manufacturing',
    'Media',
    'Professional Services',
    'Real Estate',
    'Retail',
    'Telecommunications',
    'Transportation',
    'Utilities',
    'Wholesale',
    'Other',
];
const businessActivitiesMap = businessActivities.map(service => ({label: service, value: service}));

export default function BusinessPreferences({data, onChange}) {
    return (
        <div className={styles.container}>
            <h2>Business Preferences</h2>
            <div className={styles.radio}>
                <span>Do you already have a trade name in mind?</span>
                <div className={styles.options}>
                    {options.map((option, index) => (
                        <label key={index}>
                            <input type="radio" name="has_a_name_in_mind" value={option}
                                   checked={data.has_a_name_in_mind === option}
                                   onChange={() => onChange('has_a_name_in_mind', option)}/>
                            {option}
                        </label>
                    ))}
                </div>
            </div>
            <TextInput placeholder="Trade Name" name="business_name" value={data.business_name}
                       onChange={(e) => onChange('business_name', e.target.value)}/>
            <div className={styles.radio}>
                <span>How many shareholders will the business have?</span>
                <div className={styles.options}>
                    {shareHolderOptions.map((option, index) => (
                        <label key={index}>
                            <input type="radio" name="shareholder_number" value={option}
                                   checked={data.shareholder_number === option}
                                   onChange={() => onChange('shareholder_number', option)}/>
                            {option}
                        </label>
                    ))}
                </div>
            </div>
            <div className={styles.radio}>
                <span>What is the primary activity of your business?</span>
                <CustomSelect options={businessActivitiesMap}
                              value={businessActivitiesMap.find(option => option.value === data.primary_activity)}
                              onChange={(value) => onChange('primary_activity', value.value)}/>
            </div>
            <div className={styles.radio}>
                <span>Will your business require physical office space?</span>
                <div className={styles.options}>
                    {options.map((option, index) => (
                        <label key={index}>
                            <input type="radio" name="require_physical_office" value={option}
                                   checked={data.require_physical_office === option}
                                   onChange={() => onChange('require_physical_office', option)}/>
                            {option}
                        </label>
                    ))}
                </div>
            </div>
            <TextInput placeholder="Location" name="office_location" value={data.office_location}
                       onChange={(e) => onChange('office_location', e.target.value)}/>
        </div>
    )
}